export * from './car-img-summary-basic.component';
